
import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'react-multi-carousel'
import ReactMarkdown from 'react-markdown'
import './CardsCarousel.scss'
import CustomBackgroundLeftArrow from '../../shared/arrows/customBackgroundArrowLeft'
import CustomBackgroundRightArrow from '../../shared/arrows/customBackgroundArrowRight'

const CardsCarousel = ({ title, cards }) => {

  const cardsList = cards.map((card, i) => {
    return (
      <div
        key={`card-${i}`}
        className="cardContainer"
        style={{ backgroundColor: card.color }}
      >
        <ReactMarkdown
          renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
          className={`cardContainerText ${card.labelBlack ? "" : "text-white"}`}>
          {card.description}
        </ReactMarkdown>
      </div>
    )
  })

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobileTablet: {
      breakpoint: { max: 767, min: 577 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1
    }
  }


  return (
    <div className="card container py-3 py-md-5">
      {title && (
        <div className="pb-2 cards-carousel-title">
          {title}
        </div>
      )}

      <Carousel
        responsive={responsive}
        autoPlay={cardsList.length > 4}
        autoPlaySpeed={2000}
        infinite={cardsList.length > 4}
        containerClass={'containerCarrusel'}
        customRightArrow={<CustomBackgroundRightArrow />}
        customLeftArrow={<CustomBackgroundLeftArrow />}
        removeArrowOnDeviceType={cardsList.length <= 4 && ['tablet', 'desktop']}
      >
        {cardsList}
      </Carousel>
    </div>
  )
}

export default CardsCarousel
CardsCarousel.propTypes = {
  cards: PropTypes.array.isRequired,
  title: PropTypes.string
}
